type IconProps = {
  highlighted?: boolean;
  pressed?: boolean;
  searchPage?: boolean;
  resultPage?: boolean;
};

export default function SearchLayoutIcon({ highlighted, pressed, searchPage, resultPage }: IconProps) {
  if (highlighted && !searchPage) {
    return (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23 30.9863C27.4183 30.9863 31 27.4046 31 22.9863C31 18.568 27.4183 14.9863 23 14.9863C18.5817 14.9863 15 18.568 15 22.9863C15 27.4046 18.5817 30.9863 23 30.9863Z"
          stroke="#EAEEF5"
          strokeWidth={pressed ? '3' : '2'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.9992 32.9865L28.6992 28.6865"
          stroke="#EAEEF5"
          strokeWidth={pressed ? '3' : '2'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (searchPage && !highlighted) {
    return (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23 30.9863C27.4183 30.9863 31 27.4046 31 22.9863C31 18.568 27.4183 14.9863 23 14.9863C18.5817 14.9863 15 18.568 15 22.9863C15 27.4046 18.5817 30.9863 23 30.9863Z"
          stroke="#EAEEF5"
          strokeWidth='3'
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.9992 32.9865L28.6992 28.6865"
          stroke="#EAEEF5"
          strokeWidth='3'
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23 30.9863C27.4183 30.9863 31 27.4046 31 22.9863C31 18.568 27.4183 14.9863 23 14.9863C18.5817 14.9863 15 18.568 15 22.9863C15 27.4046 18.5817 30.9863 23 30.9863Z"
        stroke="#112645"
        strokeWidth={pressed ? '3' : '2'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.9992 32.9865L28.6992 28.6865"
        stroke="#112645"
        strokeWidth={pressed ? '3' : '2'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
